import axiosIns from "@/api/axios";

export const fetchCourseCalendarData = async (filters) => {
    try {
        const response = await axiosIns.get('idp/training-calendar', {
            params: filters,
        });
        return response.data.data;
    } catch (error) {
        console.error('Error fetching course calendar data:', error);
        return [];
    }
}